import React from "react";
import styles from "./shard-repository-section.module.scss";
import { IShardRepository } from "api/entities/shard-repository";
import SidePanelSection from "components/shared-ui/side-panel-section/side-panel-section";
import { Label } from "components/shared-ui/label";

export interface IShardRepositoryReadOnlySectionProps {
  repo: IShardRepository;
}
export function ShardRepositoryReadonlySection({
  repo,
}: IShardRepositoryReadOnlySectionProps) {
  return (
    <SidePanelSection
      testId="shard-repository-readonly-section"
      title="Shard Repository Configuration"
      contentClass={styles.content}
    >
      <Label label="Type" value={repo.storageType} />
      <Label label="Region" value={repo.region} />
      <Label label="Endpoint" value={repo.endpointURL} />
    </SidePanelSection>
  );
}
